import { Outlet } from "react-router";

export function CompanyMasterDataPdfRoute() {
  return <Outlet />;
}
